export const BorderRadiuses = {
  s: '2px',
  m: '4px',
  l: '8px',
  full: '200px',
  round: '50%',
}
